import BigNumber from 'bignumber.js';
import { AccountService } from '../services/account.service';
import { ContractService } from '../services/contract.service';
import { Base } from './base';
import Abi from 'src/app/abi/holdstation-paymaster';

export class HoldstationPaymaster extends Base {
  constructor(
    public contract: string,
    protected accountService: AccountService,
    protected contractService: ContractService
  ) {
    super(contract, Abi, accountService, contractService);
  }

  getTokenFee(paymentToken: string, ethFee: any) {
    return this.call((i) => i.methods.getTokenFee(paymentToken, new BigNumber(ethFee).toDecimal().toString(10)));
  }
}
